// extracted by mini-css-extract-plugin
module.exports = {"content":"Customization_content__3tSc8","submitBtn":"Customization_submitBtn__3f4R3"};